import { Row, Space } from 'antd';
import { CSSProperties } from 'react';
import { FieldHelperProps, FieldInputProps, FieldMetaProps } from 'formik';
import Radio from 'components/new-ui/base/radio/Radio';
import { containerStatusOptions } from 'utils/containerStatus';
import { RefWrapper } from 'components/new-ui/composed/formSelect/styles';
import LabelRequiredSymbol from 'components/new-ui/base/label/LabelRequiredSymbol';

type Props = {
    refNumber?: string;
    label?: string;
    required?: boolean;
    fieldProps: FieldInputProps<any>;
    fieldHelpers: FieldHelperProps<any>;
    fieldMeta: FieldMetaProps<any>;
    style?: CSSProperties;
};

const ContainerStatusField = ({
    label,
    style,
    required = false,
    refNumber,
    fieldHelpers,
    fieldMeta,
    fieldProps,
}: Props) => {
    return (
        <Row justify="space-between">
            <Space size={8}>
                {refNumber && <RefWrapper>{refNumber}</RefWrapper>}
                {required && <LabelRequiredSymbol />}
                {label}
            </Space>

            <div style={style || { width: 375 }}>
                <Radio.Group
                    value={fieldProps.value}
                    onChange={(e) => {
                        const next = e?.target?.value;
                        fieldHelpers.setValue(next === '' || next == null ? null : Number(next));
                    }}
                    options={containerStatusOptions}
                />
                {!!fieldMeta?.error && !!fieldMeta?.touched && (
                    <div style={{ color: 'var(--error-normal)', marginTop: 4 }}>{fieldMeta.error}</div>
                )}
            </div>
        </Row>
    );
};

export default ContainerStatusField;
